// Mask phone number
export const maskPhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/(\d{2})(\d+)(\d{4})/, '$1**$3');
};

// Format date - Backend se IST aa raha hai - Z mat lagao
export const formatDate = (dateString) => {
  if (!dateString) return '';
  let myDate = dateString.replace(' ', 'T');
  const date = new Date(myDate);
  if (isNaN(date.getTime())) return dateString;
  return date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0
  }).format(amount);
};

// Status color mapping
export const getStatusColor = (approvalStatus) => {
  const statusColors = {
    'APPROVAL_PENDING': { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-300' },
    'CONFIRMED': { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300' },
    'UNCONFIRMED': { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300' },
    'CANCELLED': { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300' },
    'RETURN': { bg: 'bg-pink-100', text: 'text-pink-700', border: 'border-pink-300' },
    'SHIPPING': { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-300' },
    'OUT_FOR_DELIVERY': { bg: 'bg-cyan-100', text: 'text-cyan-700', border: 'border-cyan-300' },
    'DELIVERED': { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-300' },
  };
  return statusColors[approvalStatus] || statusColors['UNCONFIRMED'];
};

// Format approval status for display
export const formatApprovalStatus = (status) => {
  return status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
};

// Format number
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  return Number(num).toLocaleString();
};

// Normalize phone number for WhatsApp Cloud API (strips non-digits, prepends 91 if 10 digits)
export const normalizeWhatsAppPhone = (phone) => {
  if (!phone) return '';
  let digits = String(phone).replace(/[^0-9]/g, '');
  if (digits.length === 10) {
    digits = '91' + digits;
  }
  return digits;
};